



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { defaultTableConfig } from '@/core/components/table';
import WarningsDetailTable from './WarningsDetailTable.vue';

@Component({
    components: {
        WarningsDetailTable
    }
})
export default class WarningsDetail extends Vue {
    @Prop({ type: Object, required: true }) public warnings!: any;

    public get classWarningsExist() {
        return this.warnings.classWarnings && this.warnings.classWarnings.length > 0;
    }

    public get objectWarningsExist() {
        return this.warnings.objectWarnings && this.warnings.objectWarnings.length > 0;
    }
}
